import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import GamesHub from "@/pages/GamesHub";
import AlphabetGame from "@/pages/games/AlphabetGame";
import IslamicGame from "@/pages/games/IslamicGame";
import CountingGame from "@/pages/games/CountingGame";
import ShapeGame from "@/pages/games/ShapeGame";
import MemoryGame from "@/pages/games/MemoryGame";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function Chrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navigation />}
      {children}
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App bg-brand-cream min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <Chrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/games" element={<GamesHub />} />
              <Route path="/games/alphabet" element={<AlphabetGame />} />
              <Route path="/games/islamic" element={<IslamicGame />} />
              <Route path="/games/counting" element={<CountingGame />} />
              <Route path="/games/shapes" element={<ShapeGame />} />
              <Route path="/games/memory" element={<MemoryGame />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </Chrome>
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
